// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__27Le1","rootSuccess":"CompleteLink_rootSuccess__1hJZF","rootFailure":"CompleteLink_rootFailure__20yfu","isDisabled":"CompleteLink_isDisabled__d_bkz"};